import { FC } from 'react';

import BaseNavigationHeader from 'components/NavigationHeader';
import * as routes from 'features/PaymentCards/routes';

interface NavigationHeaderProps {
  backTo?: string;
}

const NavigationHeader: FC<NavigationHeaderProps> = ({ backTo }) => (
  <BaseNavigationHeader backTo={backTo} closeTo={routes.root} />
);

export default NavigationHeader;
